(() => {
  const addOnVariantId = "56167308886338";
  const addOnButtonSelector = "[data-cart-drawer-add-on]";

  function replaceCartSections(state) {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer || !state.sections) return;

    drawer.classList.remove("is-empty");
    drawer.getSectionsToRender().forEach((section) => {
      const target = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      const markup = state.sections[section.id];

      if (!target || !markup) return;
      target.innerHTML = drawer.getSectionInnerHTML(markup, section.selector);
    });
  }

  function syncAddOnButtons(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    const isAdded = cart.items.some(
      (item) => String(item.variant_id || item.id) === addOnVariantId
    );

    document.querySelectorAll(addOnButtonSelector).forEach((button) => {
      button.disabled = isAdded;
      button.setAttribute("aria-disabled", String(isAdded));
      button.removeAttribute("aria-busy");
      button.dataset.loading = "false";
      button.querySelector(".button-label").textContent = isAdded
        ? button.dataset.addedLabel
        : button.dataset.addLabel;
    });
  }

  function replaceMainCartSections(state, sectionId) {
    const markup = state && sectionId && state.sections && state.sections[sectionId];
    if (!markup) return;

    const source = new DOMParser().parseFromString(markup, "text/html");
    const sourceItems = source.querySelector("#main-cart-items .js-contents");
    const targetItems = document.querySelector("#main-cart-items .js-contents");
    const sourceFooter = source.querySelector("#main-cart-footer .js-contents-2");
    const targetFooter = document.querySelector("#main-cart-footer .js-contents-2");
    const sourceAddOn = source.querySelector(".cart-page-add-on");
    const targetAddOn = document.querySelector(".cart-page-add-on");

    if (sourceItems && targetItems) targetItems.innerHTML = sourceItems.innerHTML;
    if (sourceFooter && targetFooter) targetFooter.innerHTML = sourceFooter.innerHTML;

    if (sourceAddOn && targetAddOn) {
      targetAddOn.replaceWith(sourceAddOn);
    } else if (!sourceAddOn && targetAddOn) {
      targetAddOn.remove();
    }
  }

  async function addOnToCart(button) {
    if (button.disabled || button.dataset.loading === "true") return;

    button.dataset.loading = "true";
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    button.querySelector(".button-label").textContent = "Adding…";

    try {
      const mainCartSection = document.getElementById("main-cart-items")?.dataset.id;
      const sections = ["cart-drawer", "cart-icon-bubble"];
      if (mainCartSection) sections.push(mainCartSection);
      const response = await fetch(routes.cart_add_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          items: [{ id: Number(addOnVariantId), quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();

      if (!response.ok || state.status) {
        throw new Error(state.description || state.message || "Unable to add item.");
      }

      replaceCartSections(state);
      replaceMainCartSections(state, mainCartSection);
      syncAddOnButtons(state);
      document.dispatchEvent(
        new CustomEvent("cart:change", {
          detail: { cart: state, source: "cart-drawer-add-on" },
        })
      );
    } catch (error) {
      button.disabled = false;
      button.removeAttribute("aria-busy");
      button.dataset.loading = "false";
      button.querySelector(".button-label").textContent = button.dataset.addLabel;
      const errorContainer = document.getElementById("CartDrawer-CartErrors");
      if (errorContainer) errorContainer.textContent = error.message;
    }
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest(addOnButtonSelector);
    if (!button) return;
    event.preventDefault();
    addOnToCart(button);
  });

  document.addEventListener("cart:change", (event) => {
    if (event.detail && event.detail.source === "cart-drawer-add-on") return;
    const mainCartSection = document.getElementById("main-cart-items")?.dataset.id;
    replaceMainCartSections(event.detail && event.detail.cart, mainCartSection);
    syncAddOnButtons(event.detail && event.detail.cart);
  });

  document.addEventListener(
    "change",
    (event) => {
      const input = event.target;
      if (
        input.matches("#CartDrawer .quantity__input, #main-cart-items .quantity__input") &&
        input.dataset.variantId === addOnVariantId &&
        Number(input.value) > 1
      ) {
        input.value = 1;
      }
    },
    true
  );
})();
